import _ from 'lodash'

export default { _ }
